import { Field, FormSection } from '@atlaskit/form';
import { RadioGroup } from '@atlaskit/radio';
import lowerCase from 'lodash/lowerCase';
import * as React from 'react';

// TODO: Need to verify if this list can be fecthed from CCP or any other master source.
export const availablePricingPlan = [
  {
    name: 'commercial',
    value: 'commercial',
    label: 'Commercial',
    testId: `pricing-plan-grp-0`,
  },
  {
    name: 'community',
    value: 'community',
    label: 'Community',
    testId: `pricing-plan-grp-1`,
  },
  {
    name: 'open-source',
    value: 'open_source',
    label: 'Open-Source',
    testId: `pricing-plan-grp-2`,
  },
  {
    name: 'classroom',
    value: 'classroom',
    label: 'Class Room',
    testId: `pricing-plan-grp-3`,
  },
  {
    name: 'academic',
    value: 'academic',
    label: 'Academic',
    testId: `pricing-plan-grp-4`,
  },
];

interface Props {
  pricingEligibility?: string | null;
}
const ChangePricingEligibility = ({ pricingEligibility }: Props) => {
  const pricing = pricingEligibility ? lowerCase(pricingEligibility) : 'commercial';

  return (
    <>
      <FormSection>
        <h3>Pricing plan</h3>
        <Field name="pricingPlan" isRequired id="pricing plan" defaultValue={pricing}>
          {({ fieldProps }) => <RadioGroup {...fieldProps} options={availablePricingPlan} name="pricingPlan" />}
        </Field>
      </FormSection>
    </>
  );
};
export default ChangePricingEligibility;
